import { Box, Input, Text, InputProps } from "@chakra-ui/react";

interface Props extends InputProps {
  label?: string;
}

const TextInput = ({ label, ...rest }: Props) => (
  <Box>
    {label && (
      <Text
        fontSize={["14px", null, null, null, null, "18px"]}
        lineHeight={["8.09px", null, null, null, null, "23px"]}
        fontWeight="300"
        color="gray"
        mb={["13px", null, null, null, null, "8px"]}
      >
        {label}
      </Text>
    )}
    <Input {...rest} />
  </Box>
);

export default TextInput;
